import i18next from 'i18next';

/**
 * Sets validation errors for a mutation response.
 *
 * @param errors - Object containing error information for different fields.
 * @param setError - Function to set the error for a specific field.
 * @param t - Translation function to get localized error messages.
 *
 * The function checks for errors in the `email`, `givenname`, and `surname` fields.
 * For each field, it sets an appropriate error message based on the error type.
 * If no specific error type is found, a default error message is used.
 *
 */
export const setManageUsersFormValidationErrors = (
  errors: { [key: string]: string },
  setError: (field: string, error: { type: string; message: string }) => void,
  t: typeof i18next.t
) => {
  if (errors?.email) {
    const errorMessages = {
      duplicate: t?.('input_email_duplicate'),
      duplicate_admin: `${t?.('input_email_duplicate')}. ${t?.('input_email_duplicate_create_admin')}.`,
      duplicate_user: `${t?.('input_email_duplicate')}. ${t?.('input_email_duplicate_create_user')}.`,
      required: t?.('input_email_required'),
      default: t?.('input_email_invalid')
    };
    setError('email', {
      type: 'api',
      message: errorMessages[errors.email] || errorMessages.default
    });
  }

  if (errors?.givenname) {
    const errorMessages = {
      required: t?.('input_first_name_required'),
      default: t?.('input_first_name_invalid')
    };
    setError('givenname', {
      type: 'api',
      message: errorMessages[errors.givenname] || errorMessages.default
    });
  }

  if (errors?.surname) {
    const errorMessages = {
      required: t?.('input_last_name_required'),
      default: t?.('input_last_name_invalid')
    };
    setError('surname', {
      type: 'api',
      message: errorMessages[errors.surname] || errorMessages.default
    });
  }

  if (errors?.lang) {
    const errorMessages = {
      required: t?.('input_language_required'),
      default: t?.('input_language_invalid')
    };
    setError('lang', {
      type: 'api',
      message: errorMessages[errors.lang] || errorMessages.default
    });
  }

  if (errors?.programs) {
    const errorMessages = {
      required: t?.('input_program_required'),
      default: t?.('input_program_invalid')
    };
    setError('programs', {
      type: 'api',
      message: errorMessages[errors.programs] || errorMessages.default
    });
  }
};
